import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {BackendResponse} from "@app/interfaces/backendResponse";
import {environment} from '@env/environment';
import {ConstantsService} from '@app/services/constants/constants.service';

@Injectable({
    providedIn: 'root'
})

export class PermissionsService {

    private apiURL = environment.apiURL;

    constructor(private httpClient: HttpClient, private constants: ConstantsService) {}

    getPermittedUsersForHolidaysModule() {
        let params = new HttpParams().set('creator', this.constants.creator_id);

        return this.httpClient.get<any>(this.apiURL + '/permissions/getPermittedUsersForHolidaysModule', {params: params});
    };

    savePermittedUsersForHolidaysModule(data) {
        let params = new HttpParams().set('creator', this.constants.creator_id).set('data', JSON.stringify(data));

        return this.httpClient.get<any>(this.apiURL + '/permissions/savePermittedUsersForHolidaysModule', {params: params});
    };

    deductUserPermission(data) {
        let params = new HttpParams().set('creator', this.constants.creator_id).set('data', JSON.stringify(data));

        return this.httpClient.get<any>(this.apiURL + '/permissions/deductUserPermission', {params: params});
    };
}